var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Account',{attrs:{"me":_vm.me,"password-min-length":_vm.passwordMinLength,"active-tab":_vm.activeTab,"is-client":_vm.hasClientRole},on:{"updateMe":_vm.updateMe}})
}
var staticRenderFns = []

export { render, staticRenderFns }